import { Box, Card, Typography } from '@mui/material';
import { CustomRadio } from '../../../../v2/MUI_custom_component';

const BeneficiarySelectCard = ({ beneficiary, selected, onSelect }) => {
  return (
    <Card
      onClick={onSelect}
      sx={{
        p: 2,
        gap: 1,
        borderRadius: 2,
        border: '1px solid',
        borderColor: selected ? 'primary.main' : 'divider',
        boxShadow: 'none',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant='h2' sx={{ flex: 1 }}>
          {beneficiary.header_title}
        </Typography>
        <CustomRadio
          checked={selected}
          onChange={onSelect}
          size='medium'
          onClick={(e) => e.stopPropagation()}
        />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {beneficiary.details.map((detail, i) => (
          <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant='labelD'   sx={{ flex: 1 ,color: '#666' }}>
              {detail.display_name}
            </Typography>
            <Typography variant='body1'  sx={{ textAlign: 'right' }}>
              {detail.display_value || '—'}
            </Typography>
          </Box>
        ))}
      </Box>
    </Card>
  );
};

export default BeneficiarySelectCard;
